import { render, staticRenderFns } from "./EncaminharEstudo.vue?vue&type=template&id=5efb18b7&scoped=true&"
import script from "./EncaminharEstudo.vue?vue&type=script&lang=js&"
export * from "./EncaminharEstudo.vue?vue&type=script&lang=js&"
import style0 from "./EncaminharEstudo.vue?vue&type=style&index=0&id=5efb18b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb18b7",
  null
  
)

export default component.exports